import { Injectable } from '@angular/core';
import { AcmicService, FormBase, TextBox } from '@mapfre-design-library/src/public_api';
import { Constants } from '@models/constants';
import { FormBaseInputsService } from '@services/common/form-base-inputs.service';

@Injectable({
  providedIn: 'root',
})
export class CreateAccountService {
  constructor(private acmicService: AcmicService,
    private fbs: FormBaseInputsService) {}
  getInputs() {
    const inputs: FormBase<any>[] = [
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'signUpFirst_name',
        label: 'FIRST_NAME',
        required: true,
        type: 'text',
        validationMessageError: this.acmicService.isACMIC()
          ? 'VALID_NAME_VALIDATION_MESSAGE'
          : 'ENTER_VALID_FIRST_NAME',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'signUpLast_name',
        label: 'LAST_NAME',
        required: true,
        type: 'text',
        validationMessageError: this.acmicService.isACMIC()
          ? 'VALID_NAME_VALIDATION_MESSAGE'
          : 'ENTER_VALID_LAST_NAME',
      }),
      new TextBox({
        additionalClasses: 'form-control date',
        inputType: 'text',
        key: 'signUpDob',
        label: 'DOB',
        minLength: 10,
        maxLength: 10,
        min: '',
        max: this.fbs.getCurrentDate(),
        required: true,
        type: 'dob',
        validationMessageError: 'ENTER_VALID_DOB_VALIDATION_MESSAGE',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'noPhoneEmail_zipcode',
        label: 'ZIP code',
        minLength: 5,
        maxLength: 5,
        required: true,
        type: 'number',
        validationMessageError: 'ENTER_VALID_ZIPCODE',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'addPolicyOnSignUp',
        label: 'POLICY_NUMBER_SIGNUP',
        required: true,
        type: 'text',
        maxLength: this.acmicService.isACMIC() ? 13 : 14,
        minLength: 6,
        validationMessageError: 'ENTER_VALID_POLICY_NUMBER_MESSAGE',
      }),
    ];
    return inputs;
  }

  getCommercialAcInputs() {
    const inputs: FormBase<any>[] = [
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'createAc_companyName',
        label: 'COMPANY_NAME_LABEL',
        required: true,
        type: 'text',
        validationMessageError: '',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'email',
        key: 'createAc_email',
        label: 'EMAIL',
        minLength: 5,
        required: true,
        type: 'email',
        validationMessageError: 'VALID_EMAIL_VALIDATION_MESSAGE',
      }),
    ];
    return inputs;
  }

  getPhoneOtpInputs() {
    const inputs: FormBase<any>[] = [
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'otp',
        key: 'validateOtp',
        label: 'Security code',
        required: true,
        minLength: 6,
        maxLength: 6,
        type: 'text',
        validationMessageError: 'OTP_VALIDATION_MESSAGE',
      }),
    ];
    return inputs;
  }

  getconfirmEmailInputs() {
    const inputs: FormBase<any>[] = [
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'email',
        key: 'createAc_email',
        label: 'EMAIL',
        minLength: 5,
        required: true,
        type: 'email',
        validationMessageError: 'VALID_EMAIL_VALIDATION_MESSAGE',
      }),
    ];
    return inputs;
  }

  getNoPhoneNoEmailInputs() {
    const inputs: FormBase<any>[] = [
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'email',
        key: 'createAc_email',
        label: 'EMAIL',
        minLength: 5,
        required: true,
        type: 'email',
        validationMessageError: 'VALID_EMAIL_VALIDATION_MESSAGE',
      }),
      new TextBox({
        additionalClasses: Constants.FORM_CONTROL,
        inputType: 'text',
        key: 'noPhoneEmail_zipcode',
        label: 'ZIP code',
        minLength: 5,
        maxLength: 5,
        required: true,
        type: 'number',
        validationMessageError: 'ENTER_VALID_ZIPCODE',
      }),
    ];
    return inputs;
  }
}
